import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import './TileHeader.scss';

const TileHeader = ({
  title,
  subtitle,
  size = "md",
  style = {},
}) => {
  const location = useLocation();

  const pathname = window.location.pathname.split('/');
  let client = '';
  if (pathname.length > 1) { client = pathname[1]; }

  return (
    <div className="tile-header" style={style}>
      <div className="tile-header__breadcrumb">
        {location.pathname === `/${client}` ? (
          <span>Dashboard</span>
        ) : (
          <Link to={`/${client}`}>Dashboard</Link>
        )}
        <ChevronRight className="chevron" />
        <span>{title}</span>
      </div>
      <div className={`tile-header__title tile-header__title--${size}`}>{title}</div>
      {subtitle ? <div className="tile-header__subtitle">{subtitle}</div> : null}
    </div>
  );
};

export default TileHeader;
